function getDefaultGroupLabel() {
    return 'nsg';
}

function pickRandomSubjectGroups(groups) {
    var pickedGroups = [];
    for (var groupLabel in groups) {
        var currentGroup = groups[groupLabel];
        var subGroupIds = [];
        for(var groupIndex = 0; groupIndex < currentGroup.length; groupIndex++){
            if(currentGroup[groupIndex] != 0){
                subGroupIds.push(currentGroup[groupIndex]);
            }
        }

        var randomSubGroupIndex = getRandomInteger(0, subGroupIds.length - 1);
        pickedGroups.push(groupLabel + ':' + subGroupIds[randomSubGroupIndex]);
    }
    return pickedGroups;
}

function normalizeGroupNames() {
    console.log('normalizeGroupNames');

    var lastGroupLabel = getDefaultGroupLabel();
    var groups = {};
    const trialsCount = window.stimOrder.length;
    for (var trialIndex = 0; trialIndex < trialsCount; trialIndex++) {
        const currentTrial = window.stimOrder[trialIndex];
        var subjectGroupName = columnForTrial('subjectGroup', currentTrial);
        if (subjectGroupName == 'na' || subjectGroupName == '0') {
            listArrays[getAllCollumnsIndexOf('subjectGroup')][currentTrial] = '0';
        } else {
            group = parseGroupName(subjectGroupName, lastGroupLabel);
            lastGroupLabel = group.groupName;
            if (!groups[group.groupName]) {
                groups[group.groupName] = [];
            }
            groups[group.groupName].push(group.subGroupId);

            listArrays[getAllCollumnsIndexOf('subjectGroup')][currentTrial] = group.groupName + ':' + group.subGroupId;
        }
    }

    console.log('normalizeGroupNames', groups);
    return groups;
    

    function parseGroupName(subjectGroupName, lastGroupLabel) {
        const regex = /(.*):(\d+)/g;
        var matches;
        var group = {
            groupName: lastGroupLabel,
            subGroupId: 0
        };

        if (subGroupId = parseInt(subjectGroupName)) {
            group.subGroupId = subGroupId;
            return group;
        }

        if ((matches = regex.exec(subjectGroupName)) && matches[1] && matches[2]) {
            group.groupName = matches[1];
            group.subGroupId = parseInt(matches[2]);
        }

        return group;
    }
}


function filterTrialsBySubjectGroups(pickedSubjectGroups) {
    var subjectGroupValues = window.listArrays[getAllCollumnsIndexOf('subjectGroup')];

    /*add trials for this subjectGroup*/
    var stimOrderGroup = [];
    for (var j = 0; j < window.noTrials; j++) {
        var currentGroup = subjectGroupValues[window.stimOrder[j]];
        var lastSubGroup = -1;
        if(currentGroup !== undefined) {
            lastSubGroup = currentGroup.trim().split(':').pop();
        }
        if (
            // no group
            lastSubGroup == 0
            // group
            || pickedSubjectGroups.indexOf(currentGroup) > -1
        ) {
            console.log(subjectGroupValues[window.stimOrder[j]]);
            stimOrderGroup.push(stimOrder[j]);
        }
    }

    return stimOrderGroup;
}


function saveInfoSubjectGroups(subjectGroups) {
    var subjectGroupsString = subjectGroups.join(' ');

    subjectGroupsString = subjectGroupsString.replace(getDefaultGroupLabel() + ':', '');

    window.saveInfoColumns.push('subjectGroup');
    window.saveInfo.push(subjectGroupsString);
}

function clearDummyDefaultGroupName() {
    var subjectGroupList = window.listArrays[getAllCollumnsIndexOf('subjectGroup')];
    var defaultGroupLabel = getDefaultGroupLabel();

    for (var i = 0; i < subjectGroupList.length; i++) {
        if (subjectGroupList[i].startsWith(defaultGroupLabel)) {
            subjectGroupList[i] = subjectGroupList[i].substring(defaultGroupLabel.length + 1);
        }
    }
}

function initRandomSubjectGroups(pickedSubjectGroups) {

    /*BETWEEN SUBJECTS GROUP SELECTION*/
    if (pickedSubjectGroups.length > 0)/*execute only if any groups defined*/
    {
      /*get new stimOrder*/
      window.stimOrder = filterTrialsBySubjectGroups(pickedSubjectGroups);
      /*get number of trial for current group*/
      window.noTrialsGroup = window.stimOrder.length;
      //save info on subject group
      saveInfoSubjectGroups(pickedSubjectGroups);
  
      clearDummyDefaultGroupName();
    }
  
    console.log('stimOrder after subjectGroup', stimOrder);
}

function leaveBeforeEnd() {
    window.logExperimentEvent(window.consortEvents.DROPPED);
    var url = document.URL;
    url = url.substring(0, url.lastIndexOf("/")) + "/abort";
    var fd = new FormData();
    fd.append('counter', JSON.stringify(window.pickedSubjectGroups));
    var beaconSuccess = navigator.sendBeacon(url, fd);
  
    console.log('leaveBeforeEnd', url + "/abort", beaconSuccess, fd);
  }
  
  function initSubjectGroupAllocation(){
    var groups = normalizeGroupNames();
    if(window.evenAllocation && window.evenAllocation.length > 0){
        window.pickedSubjectGroups = window.evenAllocation;
        window.stimOrder = filterTrialsBySubjectGroups(pickedSubjectGroups);
        saveInfoSubjectGroups(pickedSubjectGroups);
    }
    else{
        window.pickedSubjectGroups = pickRandomSubjectGroups(groups);
        initRandomSubjectGroups(window.pickedSubjectGroups);
    }
    incrementSubjectGroupsCounters(window.pickedSubjectGroups);
  }

  function incrementSubjectGroupsCounters(){
    var url = document.URL;
    url = url.substring(0, url.lastIndexOf("/")) + "/increment";
    $.ajax({
        url: url,
        type: 'POST',
        data: JSON.stringify({counter: window.pickedSubjectGroups}),
        contentType: "application/json",
        success: function(){
            window.addEventListener("unload", leaveBeforeEnd, false);
            console.log('incremented even allocation counters, loaded decrement function if abandoning experiment');
        },
        error: function (){
            console.log('failed to increment even allocation counters');
        }
    });
  }
